export default ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', '0+', '0-']
